import { FeatureRollout } from '@ms/yammer-data/dist/state/ecsFeatureRollouts/types';
import { Experiment } from '@ms/yammer-data/dist/state/types';
import { useExperimentTreatmentWithoutReporting } from '@ms/yammer-hooks/dist/experiments';
import { useIsFeatureRolloutEnabled } from '@ms/yammer-hooks/dist/featureRollouts';

import { UseUIFeatureCheck } from '../types';

export const useIsPostOnBehalfOfEnabled: UseUIFeatureCheck = () =>
  useIsFeatureRolloutEnabled(FeatureRollout.PostOnBehalfOf);

export const useIsPostOnBehalfOfDraftEnabled: UseUIFeatureCheck = () =>
  useExperimentTreatmentWithoutReporting(Experiment.PostOnBehalfOfDraft) === true;
